import React, { useEffect, useState } from 'react';
import { Table, Tag, Spin, Drawer, Button, Tooltip } from 'antd';
import { Link } from 'react-router-dom';
import { PartitionOutlined } from '@ant-design/icons';
import moment from 'moment';
import useFlowEnrollmentStore from '../../stores/useFlowEnrollmentStore';
import PhoneDisplay from '../common/PhoneDisplay';
import ContactFlowStepper from './ContactFlowStepper';

const SOURCE_COLORS = { campaign: 'purple', bot: 'blue', manual: 'green' };
const STATUS_COLORS = { active: 'blue', completed: 'green', dropped: 'red' };

export default function ContactEnrollmentHistory({ contactId }) {
    const { contactEnrollments, contactEnrollmentsLoading, fetchContactEnrollments } = useFlowEnrollmentStore();
    const [boardEnrollment, setBoardEnrollment] = useState(null);

    useEffect(() => {
        if (contactId) fetchContactEnrollments(contactId);
    }, [contactId]);

    const columns = [
        {
            title: 'Flow',
            dataIndex: 'flow_name',
            key: 'flow_name',
        },
        {
            title: 'Campaign',
            dataIndex: 'campaign_name',
            key: 'campaign_name',
            render: (name, record) => record.campaign_id && name
                ? <Link to={`/campaign/${record.campaign_id}`}>{name}</Link>
                : '—',
        },
        {
            title: 'Sent from',
            dataIndex: 'bot_mobile',
            key: 'bot_mobile',
            render: (mobile, record) => {
                if (!mobile) return '—';
                return (
                    <Tooltip title={record.bot_name || ''}>
                        <span><PhoneDisplay value={mobile} /></span>
                    </Tooltip>
                );
            },
        },
        {
            title: 'By',
            dataIndex: 'enrolled_by_name',
            key: 'enrolled_by_name',
            render: (name) => name || '—',
        },
        {
            title: 'Source',
            dataIndex: 'source',
            key: 'source',
            render: (source) => <Tag color={SOURCE_COLORS[source] || 'default'}>{source}</Tag>,
        },
        {
            title: 'Enrolled',
            dataIndex: 'created_at',
            key: 'created_at',
            render: (date) => moment(date).format('MMM D, YYYY'),
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (status) => <Tag color={STATUS_COLORS[status] || 'default'}>{status}</Tag>,
        },
        {
            title: '',
            key: 'actions',
            width: 50,
            render: (_, record) => (
                <Tooltip title="View progress on this flow">
                    <Button
                        type="text"
                        size="small"
                        icon={<PartitionOutlined />}
                        onClick={() => setBoardEnrollment(record)}
                    />
                </Tooltip>
            ),
        },
    ];

    if (contactEnrollmentsLoading) return <Spin style={{ display: 'block', margin: '32px auto' }} />;

    return (
        <>
            <Table
                columns={columns}
                dataSource={contactEnrollments}
                rowKey="id"
                size="small"
                pagination={false}
                locale={{ emptyText: 'No flow enrollments yet' }}
            />
            <Drawer
                title={boardEnrollment ? boardEnrollment.flow_name : ''}
                open={!!boardEnrollment}
                onClose={() => setBoardEnrollment(null)}
                width={Math.min(640, Math.max(480, window.innerWidth - 400))}
                placement="right"
                destroyOnClose
            >
                {boardEnrollment && <ContactFlowStepper enrollment={boardEnrollment} />}
            </Drawer>
        </>
    );
}